// Auto-generated by the set-version.js script.
export const ADMIN_UI_VERSION = '2.0.1';
